module.exports = __webpack_public_path__ + "static/media/cornmarket.2697d92a.png";